import { BondStatuses, Step } from "./FormBondApp.constants";

export type RecoveryData = {
  email: string;
  business_dba: string;
  business_fein_number: string;
  business_name: string;
  business_type_id: string;
  fax: string | null;
  first_name: string;
  full_name: string;
  last_name: string;
  mailing_city: string;
  mailing_state: string;
  mailing_street: string;
  mailing_zip: string;
  middle_name: string;
  name: string;
  phone: string;
  salesforce_id: string | null;
  short_name: string;
  suffix: string;
};

export type BondRecordResponse = {
  data: {
    record: BondRecordData;
    access_key: string;
    record_salesforce_id: string;
  };
};

export type BondRecordData = {
  id: string;
  product: any;
  principal: RecoveryData;
  status_name: BondStatuses;
  bond_premium_amount: number;
  product_name: string;
  salesforce_allow_cc_payment: boolean;
  salesforce_allow_ach_payment: boolean;
  adjustments_records: any; //TODO: find out what a type
  pdf_bond_sample_file_id: string | null;
  pdf_electronic_bond_file_id: string | null;
  product_id: string;
  salesforce_payment_link: string;
  fees_total: number;
  net_due_total: number;
  is_credit_required: boolean;
  is_underwriting: boolean;
  principal_email: string;
  product_obligee_name: string;
  product_base_name: string;
  obligee_name: string;
  workflow_status: WorkflowStatus;
  is_shipping_required: boolean;
  is_issued_bond_pdf_available: boolean;
  is_bond_sample_pdf_available: boolean;
};

export enum WorkflowStatus {
  CUSTOMER = "CUSTOMER",
  PROCESSING = "PROCESSING",
  COMPLETE = "COMPLETE",
  VOID = "VOID",
}

export type ShippingOption = {
  city: string;
  id: number | null;
  price: number;
  recipient_name: string;
  record_salesforce_id: string;
  shipping_method_id: string;
  state_code: string;
  street: string;
  zip: string;
};

export type ShippingServiceResponse = {
  data: {
    options: ShippingOption[];
  };
};

export type FormItem = {
  data: FormData;
  setData: React.Dispatch<React.SetStateAction<FormData>>;
  active: boolean;
  isSkipBond?: boolean;
};

export type StepItem = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export type StepHeader = {
  width: string;
  id: number;
  back?: (value?: boolean) => Step;
};

export type BondInfo = {
  extraInfo?: string[];
  title: string;
  subTitle?: string;
  stateDisclaimer?: string[];
  submitInfo?: string[];
};

export type SidebarData = {
  name: string;
  location: string;
  phone: string;
  description: string;
  partnershipName?: string;
  agencyName?: string;
};

export type FormData = {
  [key: string]: any;
} | null;
